export default __webpack_public_path__ + "static/media/box-5.a6b42117.png";